import * as React from "react";

import { DataSourceAddressParseControllerProvider } from "./data-source-address-parse-controller";

export const DataSourceAddressParseProvider: React.FunctionComponent = (
  props
) => {
  return (
    <DataSourceAddressParseControllerProvider>
      {props?.children || []}
    </DataSourceAddressParseControllerProvider>
  );
};
